/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_S2_TitleInputs */

const en_landing_guide_s2_title = /** @type {(inputs: Landing_Guide_S2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How drift-free editing works`)
};

const zh_landing_guide_s2_title = /** @type {(inputs: Landing_Guide_S2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无漂移编辑是如何实现的`)
};

/**
* | output |
* | --- |
* | "How drift-free editing works" |
*
* @param {Landing_Guide_S2_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_s2_title = /** @type {((inputs?: Landing_Guide_S2_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_S2_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_s2_title(inputs)
	return zh_landing_guide_s2_title(inputs)
});
export { landing_guide_s2_title as "landing.guide.s2_title" }